import { Typography, Box } from '@mui/material';
import React from 'react'
import { dataConstants } from '../../../../constants';
import { getRandomStr, getTabData } from '../../../../helpers';
import ChartItem from '../../../_common/Skeleton/chart';
import dynamic from 'next/dynamic';
import CommitRoundedIcon from '@mui/icons-material/CommitRounded';
import { getChartSeriesColor } from '../../../../utils';

const D3Chart = dynamic(() => import('../../../_common/D3Chart'),
  { loading: () => <ChartItem /> })

const { ECO_SECTION_CODES } = dataConstants || {};

function HistoricalYields({ data, getChartData, themes, yData, yieldInverBelly }) {

  // const yieldInverBelly = data && data.find(d => d.section_code === ECO_SECTION_CODES.YIELD_INVER_BELLY_CHART) ? data.find(d => d.section_code === ECO_SECTION_CODES.YIELD_INVER_BELLY_CHART) : undefined;
  const yieldInverBellyChart = yieldInverBelly && yieldInverBelly.tabData ? getChartData(yieldInverBelly.tabData, getTabData(yData, yieldInverBelly, ECO_SECTION_CODES.YIELD_DATA)) : undefined;

  return (
    <>
      {yieldInverBelly && yieldInverBellyChart !== undefined &&
        <Box component="div" className="col-md-6">
          <Box className="section">
            <Typography component="h4" className="option-title" sx={{ mr: 'auto', fontWeight: 600 }} >
              {yieldInverBelly.section_name}
            </Typography>
          </Box>
          <Box component="div" className="option-content eco-chart" sx={{ py: 2, pr: 3, minHeight: { md: '18.3rem', xs: '11.3rem' } }}>
            <D3Chart
              showChart={true}
              noHeader
              // maxHeight={chartProps.maxHeight}
              scale={1}
              // onClick={code => handleClick(code)}
              chart={{ ...yieldInverBellyChart, id: yieldInverBelly.section_code }}
              // userName={`@${chart.code.split('@')[1]}`}
              themes={themes}
              type={dataConstants.CHART_STATE.VIEW}
              // axisTextMargin={chartProps.axisTextMargin}
              //chartMargin={{left: 40, bottom: 48 }}
              //axisTextMargin={{ y: 96 }}
              // wrapperClass="StockCardImage"
              //showLegend={false}
              chartMargin={{ bottom: 48 }}
              showCrosshair
            />
          </Box>
          <Box component="div" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
            {yieldInverBellyChart?.series.map((d, i) => {
              return (
                d?.legend?.label && d?.legend?.label !== '' &&
                <Box key={getRandomStr(4)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1, mr: 1.5 }}>
                  <CommitRoundedIcon sx={{ mr: .7, width: '1em !important', fontSize: '1.1rem !important', color: getChartSeriesColor(d, yieldInverBellyChart?.currTheme.pallete[i]) }} />
                  <Typography variant="p" sx={{ fontSize: '.67rem', fontWeight: 600 }}>{d.legend.label}</Typography>
                </Box>
              );
            })}
          </Box>
        </Box>}
    </>
  )
}

export default HistoricalYields
